// ** Redux imports
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";

// ** Types imports
import type { RootState, AppDispatch } from "./index";

const usePreferencesState = () => {
  const preferencesState = useSelector((state: RootState) => state.preferences);

  return preferencesState;
};

export const useEnums = () => {
  return useSelector((state: RootState) => state.enums);
};

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default usePreferencesState;
